var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 621,
    height: 511,
    viewBox: "0 0 621 511",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 606,
    height: 471
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 64.8276V316.481C55.4216 423.071 167.524 519.121 318 443.178C382.674 410.531 489.172 357.128 621 398.639V0L15 64.8276Z",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    width: 606,
    height: 470,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.6 22.7706V277.163L574.661 277.683L405.788 293.153L399.849 293.673L385.666 295L380.419 295.462L375.922 295.866L373.558 296.097L366.006 296.79L360.009 297.309H359.894L352.053 298.002L274.333 305.102L260.035 306.43L233.398 308.854L219.099 310.182L192.462 312.606L178.164 313.934L151.527 316.358L137.228 317.686L110.591 320.111L96.2926 321.438L69.6557 323.863L55.3571 325.19L13.3838 329V-11.3447L408.152 12.4379L500.458 17.9794L580.6 22.7706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6082 255.494V324.681L72.7773 325.968V255.494H86.6082Z",
    fill: "#A0B8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.148 228.088V321.046L112.317 322.332V228.088H126.148Z",
    fill: "#A0B8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.745 180.714V317.466L151.914 318.697V180.714H165.745Z",
    fill: "#A0B8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.285 125.958V313.831L191.454 315.117V125.958H205.285Z",
    fill: "#A0B8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.882 137.703V310.251L231.051 311.482V137.703H244.882Z",
    fill: "#A0B8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.422 99.334V306.615L270.591 307.902V99.334H284.422Z",
    fill: "#A0B8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5928 292.241C53.5928 292.241 243.042 257.004 320.338 122.322L326.584 125.901C326.584 125.901 259.828 250.293 53.5928 295.989V292.241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.188 122.322L331.157 135.466V113.317L310.188 122.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5928 292.241C53.5928 292.241 243.042 257.004 320.338 122.322L326.584 125.901C326.584 125.901 259.828 250.293 53.5928 295.989V292.241Z",
    fill: "#0B45E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.188 122.322L331.157 135.466V113.317L310.188 122.322Z",
    fill: "#0B45E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.777 539.738L148.289 573.688C138.641 526.65 140.872 350.969 257.597 311.761C284.478 324.178 295.298 332.176 295.298 332.176L355.696 301.694C355.696 301.75 440.633 311.258 434.777 539.738Z",
    fill: "#0B45E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.255 583.196L434.554 547.12C436.394 520.665 433.438 445.046 412.581 369.091C406.892 348.285 395.292 330.219 386.425 320.99C392.504 309.58 400.925 299.177 410.963 292.465L405.163 285.697C421.838 273.337 437.956 266.457 437.956 266.457L506.385 247.552C506.385 247.552 513.021 250.405 523.116 256.613L522.112 261.759C550.889 280.552 592.66 306.783 610.841 403.321C629.022 499.858 617.255 583.196 617.255 583.196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.321 252.922C330.321 252.922 342.033 277.755 336.344 298.562C336.344 298.562 336.065 294.143 329.652 292.018C327.588 287.823 325.748 267.8 325.748 267.8L330.321 252.922Z",
    fill: "#4F7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.142 360.813C298.142 360.813 343.427 335.924 355.696 301.75L330.321 291.57L325.748 266.457L273.102 270.149C273.102 270.149 276.503 290.507 276.894 299.009C266.465 299.792 254.307 305.833 254.307 305.833L251.853 309.636L249.678 316.739C249.623 316.795 267.692 339.056 298.142 360.813Z",
    fill: "#FFB5C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.202 317.187C308.571 320.599 310.857 314.614 310.857 314.614C310.857 314.614 310.021 291.403 311.582 284.97C313.144 278.538 318.665 275.686 318.665 275.686L297.64 268.359L273.101 270.093C273.101 270.093 276.503 290.452 276.894 298.953C270.369 299.457 263.174 301.974 258.713 303.819L257.653 311.762L271.707 339.336C278.957 345.936 287.88 353.374 298.253 360.757C298.253 360.757 305.615 356.73 315.152 349.683C314.204 349.068 313.032 348.397 311.638 347.781C289.944 338.273 289.832 313.775 299.202 317.187Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.046 270.149C273.046 270.149 276.503 288.27 276.838 299.009C254.251 306.56 236.015 313.943 236.015 313.943L239.919 263.661L263.342 252.922L273.046 270.149Z",
    fill: "#4F7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.425 161.026C276.392 154.594 300.707 150.064 314.761 167.906C319.334 173.723 323.796 180.099 324.354 189.495C326.919 236.03 259.661 178.589 259.661 178.589C259.661 178.589 262.171 169.92 270.425 161.026Z",
    fill: "#4F7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.913 165.054C306.173 169.137 317.605 177.247 324.354 194.809C324.354 203.59 327.031 207.673 331.102 211.7C335.173 215.783 340.527 241.456 331.102 266.457C325.023 282.006 303.496 277.923 303.496 277.923C303.496 277.923 285.315 279.937 273.157 274.567C260.999 269.142 254.307 233.346 254.307 233.346L259.717 178.589L281.913 165.054Z",
    fill: "#FFB5C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.234 261.087C319.446 260.976 317.159 262.15 315.486 262.486C313.2 262.989 312.586 259.969 314.929 258.571C312.809 259.521 310.132 259.969 302.157 258.403C294.852 257.004 289.832 251.467 288.55 249.901C288.661 249.677 288.717 249.51 288.829 249.286C292.677 242.295 306.898 233.737 306.898 233.737C306.898 233.737 309.519 233.346 311.248 233.737C310.913 232.618 310.802 231.668 310.746 230.94C311.304 230.773 311.806 230.605 312.196 230.325C315.598 228.088 315.208 223.39 313.534 223.781C311.861 224.173 308.794 224.732 306.507 223.222C304.221 221.712 297.975 217.181 296.748 207.673C296.023 201.8 290.279 197.382 286.04 197.102C281.746 196.822 271.707 197.102 263.342 202.248C260.609 203.926 258.434 205.771 256.817 207.337L254.251 233.29C254.251 233.29 261 269.086 273.102 274.511C285.259 279.936 303.44 277.867 303.44 277.867C303.44 277.867 322.402 281.446 329.763 269.086C329.708 263.94 326.473 261.311 322.234 261.087Z",
    fill: "url(#paint1_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.33 247.552C506.33 247.552 505.437 252.698 493.335 264.667C481.122 278.538 467.347 289.221 456.862 296.324C456.36 296.66 455.858 296.996 455.356 297.331C454.966 297.611 454.576 297.835 454.185 298.114C453.906 298.282 453.627 298.506 453.349 298.673C452.791 299.065 452.233 299.401 451.676 299.736C451.397 299.904 451.118 300.072 450.895 300.24C449.501 301.134 448.162 301.917 446.991 302.645C446.656 302.868 446.322 303.036 445.987 303.26C443.924 304.49 442.306 305.385 441.302 305.889C441.247 305.945 441.135 306 441.079 306C440.466 306.336 440.131 306.504 440.131 306.504C440.131 306.504 440.131 306.504 440.075 306.448C439.072 304.267 417.322 257.9 417.322 256.11C417.322 253.425 417.377 246.21 417.377 246.21C417.377 246.21 417.322 246.21 417.266 246.21C415.704 246.378 399.085 248 383.023 243.469C370.196 244.812 368.858 230.605 372.26 226.578C375.606 222.551 372.26 219.139 372.26 219.139H370.252C370.252 219.139 367.575 218.468 367.575 215.112C367.575 211.756 372.316 207.002 372.316 207.002C372.316 207.002 366.237 201.577 368.3 198.892C373.041 194.138 373.041 188.768 373.041 188.768C363.616 186.084 362.946 179.316 362.946 179.316C362.946 179.316 375.773 168.521 385.868 161.082C387.206 154.315 381.127 146.876 383.191 142.178C386.537 132.054 397.746 118.854 408.12 111.08C432.379 92.8462 477.553 100.285 492.331 117.848C507.166 135.41 507.835 163.823 499.08 180.043C490.324 196.263 491.662 207.058 493.001 218.58C494.172 229.934 506.33 247.552 506.33 247.552Z",
    fill: "#FFB5C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.354 252.922C327.031 254.935 325.636 242.015 325.636 241.679C324.075 240.449 318.888 240.561 318.888 240.561C316.156 242.742 290.669 249.51 290.669 249.51L295.354 252.922Z",
    fill: "#FE5B88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.573 252.363C294.573 252.363 302.771 247.496 313.535 246.154C318.275 245.483 322.29 245.483 322.29 245.483V240.729C322.29 240.729 311.527 239.386 300.708 244.085C291.283 248.224 290.613 249.51 290.613 249.51L294.573 252.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.815 253.146C299.815 253.146 308.794 248.448 318.275 247.776V250.629C318.275 250.629 313.479 253.314 299.815 253.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.163 226.858C315.709 228.256 315.263 229.766 315.263 229.766C315.263 229.766 317.829 228.871 319.446 229.263C321.063 229.71 320.896 225.348 318.163 226.858Z",
    fill: "#FE5B88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.319 161.866C286.319 161.866 275.946 168.186 269.309 179.036C264.178 187.482 259.661 199.172 259.661 235.695C259.661 253.369 264.123 265.003 272.098 278.371C279.571 290.899 255.59 309.86 251.798 319.592C243.488 340.958 243.098 372.559 249.623 406.174H238.692C238.692 406.174 169.593 342.076 217.834 201.801C228.096 171.989 255.423 144.471 286.319 161.866Z",
    fill: "#4F7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.476 280.943C275.109 303.987 270.815 382.458 265.182 412.27H261.947C261.947 412.27 271.205 337.042 259.772 302.365C248.34 267.687 269.476 280.943 269.476 280.943Z",
    fill: "#4F7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.692 338.217L256.426 330.666C256.426 330.666 255.757 369.091 264.29 397.224V404.384C264.29 404.384 235.401 380.277 237.52 337.378C239.64 294.478 256.426 289.277 256.426 289.277L264.29 301.861L267.692 338.217Z",
    fill: "#4F7CF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.09 310.307L465.06 303.204C467.29 302.477 469.744 302.701 471.752 303.931C476.046 306.56 483.519 311.482 486.642 316.18C465.339 309.021 444.09 310.307 444.09 310.307Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522 261.759C522 261.759 510.902 299.96 501.979 317.578C526.573 304.994 540.962 276.245 540.962 276.245C540.962 276.245 530.031 266.793 522 261.759Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.967 142.066C380.959 146.82 387.038 154.259 385.644 160.97C375.55 168.409 362.723 179.204 362.723 179.204C362.723 179.204 363.392 185.972 372.817 188.656C372.817 188.656 372.817 194.082 368.077 198.78C366.069 201.465 372.148 206.89 372.148 206.89C372.148 206.89 367.407 211.644 367.407 215C367.407 218.356 370.084 219.083 370.084 219.083H372.092C372.092 219.083 375.438 222.439 372.092 226.522C368.746 230.605 370.084 244.755 382.855 243.413C399.698 248.167 417.209 246.098 417.209 246.098C417.209 246.098 417.209 246.154 417.209 246.266L434.386 234.632C419.273 243.637 405.052 242.015 405.052 242.015C411.8 214.329 392.894 192.683 385.532 185.244C388.879 169.024 399.029 164.941 405.052 163.599C401.706 162.928 399.642 160.243 400.981 159.516C402.319 158.845 407.729 159.516 407.729 159.516L402.319 150.064C413.752 119.637 435.335 112.869 435.335 112.869L418.938 104.647C414.867 106.214 411.075 108.283 407.673 110.856C397.579 118.798 386.369 131.942 382.967 142.066Z",
    fill: "url(#paint4_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.806 296.269C456.806 296.269 456.806 296.324 456.806 296.269C456.304 296.604 455.747 296.94 455.301 297.275C454.91 297.555 454.52 297.779 454.129 298.058C453.85 298.226 453.572 298.45 453.293 298.618C452.735 299.009 452.177 299.345 451.62 299.68C451.341 299.848 451.062 300.016 450.839 300.184C449.445 301.079 448.106 301.862 446.935 302.589C446.6 302.813 446.266 302.98 445.931 303.204C443.868 304.435 442.25 305.329 441.247 305.833C441.191 305.889 441.079 305.945 441.024 305.945C440.41 306.28 440.075 306.448 440.075 306.448C440.075 306.448 440.075 306.448 440.02 306.392C439.016 304.211 417.266 257.844 417.266 256.054C417.266 253.369 417.322 246.154 417.322 246.154C417.322 246.154 417.266 246.154 417.21 246.154C422.675 241.903 431.152 237.205 440.02 230.158C440.02 230.158 433.941 243.581 432.156 254.264C432.77 259.578 451.787 288.662 456.806 296.269Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.81 112.366C401.148 113.709 404.048 114.1 404.048 114.1C404.048 114.1 413.975 112.366 423.4 115.722C413.975 124.503 413.083 130.768 413.083 130.768C413.083 130.768 423.4 140.052 425.408 152.86C422.062 167.067 425.408 179.875 425.408 179.875L430.817 182.56C430.817 182.56 435.558 158.901 450.337 158.901C465.171 158.901 460.598 178.365 460.598 178.365C460.598 178.365 466.789 215.056 492.61 216.734C492.61 216.734 491.439 205.548 493.502 194.753C495.51 183.958 509.006 173.779 506.329 147.435C503.652 121.092 486.81 99.4461 448.385 98.7749C409.96 98.1037 399.81 112.366 399.81 112.366Z",
    fill: "#0B45E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.448 193.019C303.329 195.088 303.329 204.597 306.842 209.854C310.411 215.112 313.646 216.174 315.821 218.076C314.204 215.112 313.534 212.371 314.204 210.414C318.721 210.749 324.577 209.854 328.258 208.568C325.804 205.324 324.298 201.353 324.298 194.809C323.852 193.634 323.35 192.46 322.848 191.341C318.777 190.614 309.24 189.383 305.448 193.019Z",
    fill: "url(#paint6_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.6621 80.7646C71.6621 107.108 92.9661 128.474 119.233 128.474C145.501 128.474 166.805 107.108 166.805 80.7646C166.805 54.4209 145.501 33.0552 119.233 33.0552C92.9661 33.0552 71.6621 54.4209 71.6621 80.7646ZM90.2333 81.1561C90.2333 65.1038 103.228 52.0718 119.233 52.0718C135.239 52.0718 148.234 65.1038 148.234 81.1561C148.234 97.2084 135.239 110.24 119.233 110.24C103.228 110.24 90.2333 97.2084 90.2333 81.1561Z",
    fill: "#FE5B88"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 33,
    width: 96,
    height: 96
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.6621 80.7646C71.6621 107.108 92.9661 128.474 119.233 128.474C145.501 128.474 166.805 107.108 166.805 80.7646C166.805 54.4209 145.501 33.0552 119.233 33.0552C92.9661 33.0552 71.6621 54.4209 71.6621 80.7646ZM90.2333 81.1561C90.2333 65.1038 103.228 52.0718 119.233 52.0718C135.239 52.0718 148.234 65.1038 148.234 81.1561C148.234 97.2084 135.239 110.24 119.233 110.24C103.228 110.24 90.2333 97.2084 90.2333 81.1561Z",
    fill: "#FE5B88"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.787 24.6094V80.7644L64.9141 52.0717L118.787 24.6094Z",
    fill: "#FFB5C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8698 115.162L64.9141 52.0718L118.787 80.7645L67.8698 115.162Z",
    fill: "#FE84A6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.379 424.094C100.586 420.352 89.2919 436.326 89.2919 436.326C90.3542 422.474 79.9545 412.197 65.9205 424.15C55.1854 433.31 56.695 439.174 52.4457 447.384C47.805 456.265 41.0396 455.315 41.1514 467.547C41.1514 467.547 56.1359 454.142 64.97 454.869L41.9901 477.042L37.6849 511C37.6849 511 39.474 504.968 45.233 505.415C51.0479 505.862 83.1415 511.447 91.6402 504.186C100.139 496.925 81.4642 472.63 81.7437 469.446C82.0233 466.262 88.1177 462.8 99.0206 472.406C109.923 482.013 108.805 492.569 108.861 491.284C108.973 490 127.983 474.64 126.641 466.765C125.299 458.89 94.8831 446.491 94.8831 446.491C94.8831 446.491 106.01 440.906 115.571 442.916C125.132 444.927 136.761 461.738 136.929 460.119C137.153 458.499 140.172 427.836 120.379 424.094ZM94.1003 416.051C94.1003 416.051 97.7905 408.176 98.5733 398.123C95.1067 398.234 91.137 398.29 88.9564 398.29C84.4275 398.234 84.5952 391.532 89.1241 390.415C91.6961 389.745 94.939 389.522 98.4615 389.354C97.7905 383.713 95.8336 377.904 91.6402 372.71C83.5329 375.503 76.5998 374.888 86.5522 367.46C71.9591 354.837 49.091 355.284 0 369.359C21.3026 371.816 36.958 380.194 48.5318 386.561C69.0516 397.899 94.1003 416.051 94.1003 416.051ZM209 392.538C209 392.538 207.77 382.037 204.639 373.995C193.904 379.356 191.108 371.816 197.818 366.846C197.818 366.846 189.487 344.114 164.662 348.582C139.837 353.106 150.907 370.141 137.041 375.558C128.095 379.077 119.205 361.316 108.302 382.149C97.9583 402.032 113.166 422.865 152.585 422.642C152.585 422.642 156.498 405.774 162.034 406.836C168.408 408.064 164.773 417.001 160.971 425.714L178.528 431.969C178.528 431.969 183.56 418.341 187.362 420.017C191.22 421.692 184.455 434.203 184.455 434.203L191.779 437.163C191.779 437.163 207.49 412.253 208.105 397.564C194.519 397.955 185.125 390.694 209 392.538Z",
    fill: "#4072F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 325.569,
    y1: 349.777,
    x2: 268.401,
    y2: 270.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    stopColor: "#FEADC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3861,
    stopColor: "#FEA7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5604,
    stopColor: "#FE94B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7628,
    stopColor: "#FE779C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9193,
    stopColor: "#FE5B88"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(298.794 212.296) scale(81.8694 224.885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEADC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1965,
    stopColor: "#FEA1BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5486,
    stopColor: "#FE82A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9193,
    stopColor: "#FE5B88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 448.318,
    y1: 286.731,
    x2: 469.954,
    y2: 320.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.013661,
    stopColor: "#668EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9854,
    stopColor: "#668EF3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 493.368,
    y1: 253.205,
    x2: 521.489,
    y2: 296.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.013661,
    stopColor: "#668EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9854,
    stopColor: "#668EF3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(383.39 174.389) scale(84.4554 84.7005)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    stopColor: "#FEADC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3861,
    stopColor: "#FEA7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5604,
    stopColor: "#FE94B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7628,
    stopColor: "#FE779C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9193,
    stopColor: "#FE5B88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 461.633,
    y1: 298.296,
    x2: 420.665,
    y2: 241.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2612,
    stopColor: "#FEADC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3861,
    stopColor: "#FEA7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5604,
    stopColor: "#FE94B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7628,
    stopColor: "#FE779C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9193,
    stopColor: "#FE5B88"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(343.07 174.442) scale(57.258 57.4242)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3813,
    stopColor: "#FEADC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#FE8EAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9193,
    stopColor: "#FE5B88"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 606,
    height: 470,
    fill: "white",
    transform: "translate(15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/login_bg.925a99609ea8f85ec03f715cea91301d.svg";
export { ForwardRef as ReactComponent };